<template>
  <div class="master-material-detail-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('edit') }}</strong>
              <div class="card-actions">
              </div>
            </div>
            <b-form class="row" v-if="item.id != null">

              <b-col cols="9" align-self="center">
                <b-form-group v-bind:label="$t('material_id')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.material_id" :options="materials">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('supplier_uom_id')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.supplier_uom_id" :options="uoms">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('smaller_uom_id')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.smaller_uom_id" :options="uoms">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('smaller_uom_detail_id')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.smaller_uom_detail_id" :options="smaller_uom_details">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('outlet_uom_id')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.outlet_uom_id" :options="uoms">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('outlet_uom_detail_id')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.outlet_uom_detail_id" :options="outlet_uom_details">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('recipe_uom_id')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.recipe_uom_id" :options="uoms">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('recipe_uom_detail_id')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.recipe_uom_detail_id" :options="recipe_uom_details">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('report_uom_id')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.report_uom_id" :options="uoms">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('material_detail_code')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.code" disabled>
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('material_detail_name')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.name">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('fixed_unit')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.fixed_unit_id" :options="uoms">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('active')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}"
                            v-model="item.is_active" v-bind:checked="item.is_active" :value="1" :uncheckedValue="0"/>
                </b-form-group>

              </b-col>
            </b-form>
            <div slot="footer" class="text-center">
              <router-link :to="{name: model + '_list'}">
                <b-button variant="default"><i class="fa fa-arrow-left"></i> {{$t('back')}}</b-button>
              </router-link>
<!--              <b-button variant="success" v-on:click="updateItem" v-if="id != null && $auth.check(model + '.update')"><i-->
              <b-button variant="success" v-on:click="updateItem" v-if="id != null"><i
                class="fa fa-save"></i> {{$t('update')}}
              </b-button>
<!--              <b-button variant="success" v-on:click="createItem" v-if="id == null && $auth.check(model + '.create')"><i-->
              <b-button variant="success" v-on:click="createItem" v-if="id == null"><i
                class="fa fa-save"></i> {{$t('save')}}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  .switch {
    margin-bottom: 0px;
    margin-top: 7px;
    float: left;
    margin-right: 5px;
  }
</style>
<script>
  import cSwitch from '../../../../components/Switch'
  import {
    generateCode,
    get,
    create,
    update
  } from '@/api/master_material_detail'
  import {getMasterMaterialList} from '@/api/master_material'
  import {getMasterSupplierList} from '@/api/master_supplier'
  import {getMasterUomList} from '@/api/master_uom'
  import {getMasterUomDetailList} from '@/api/master_uom_detail'

  export default {
    name: 'MasterMaterialForm',
    props: {
      id: {
        default: null
      }
    },
    components: {
      cSwitch
    },
    computed: {},
    data: function () {
      return {
        model: 'master_material_detail',
        edit: 0,
        item: {
          id: null,
          material_id: '',
          supplier_id: '',
          supplier_uom_id: '',
          outlet_uom_id: '',
          outlet_uom_detail_id: '',
          recipe_uom_id: '',
          recipe_uom_detail_id: '',
          smaller_uom_id: '',
          smaller_uom_detail_id: '',
          report_uom_id: '',
          code: '',
          name: '',
          fixed_unit_id: '',
          is_active: 1
        },
        languages: Object.keys(this.$i18n.messages),
        materials: [],
        suppliers: [],
        uoms: [],
        uom_details: [],
        smaller_uom_details: [],
        outlet_uom_details: [],
        recipe_uom_details: []
      }
    },
    methods: {
      /**
       * Get List Smaller Uom Detail
       */
      getListSmallerUomDetail(from_uom_id, to_uom_id) {
        this.$Progress.start()
        this.smaller_uom_details = []
        for (let i in this.uom_details) {
          if (parseInt(this.uom_details[i].from_uom_id) == parseInt(from_uom_id) && parseInt(this.uom_details[i].to_uom_id) == parseInt(to_uom_id)) {
            this.smaller_uom_details.push({
              label: this.uom_details[i].name,
              value: this.uom_details[i].id
            })
          }
        }
        this.$Progress.finish()
      },
      /**
       * Get List Outlet Uom Detail
       */
      getListOutletUomDetail(from_uom_id, to_uom_id) {
        this.$Progress.start()
        this.outlet_uom_details = []
        for (let i in this.uom_details) {
          if (parseInt(this.uom_details[i].from_uom_id) == parseInt(from_uom_id) && parseInt(this.uom_details[i].to_uom_id) == parseInt(to_uom_id)) {
            this.outlet_uom_details.push({
              label: this.uom_details[i].name,
              value: this.uom_details[i].id
            })
          }
        }
        this.$Progress.finish()
      },
      /**
       * Get List Recipe Uom Detail
       */
      getListRecipeUomDetail(from_uom_id, to_uom_id) {
        this.$Progress.start()
        this.recipe_uom_details = []
        for (let i in this.uom_details) {
          if (parseInt(this.uom_details[i].from_uom_id) == parseInt(from_uom_id) && parseInt(this.uom_details[i].to_uom_id) == parseInt(to_uom_id)) {
            this.recipe_uom_details.push({
              label: this.uom_details[i].name,
              value: this.uom_details[i].id
            })
          }
        }
        this.$Progress.finish()
      },
      /**
       * Get List Material
       */
      getListMaterial() {
        this.$Progress.start()
        getMasterMaterialList().then((response) => {
          for (let i in response.data.data) {
            this.materials.push({
              label: response.data.data[i].code + ' - ' + response.data.data[i].name,
              value: response.data.data[i].id,
              code: response.data.data[i].code
            })
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * Get List Supplier
       */
      getListSupplier() {
        this.$Progress.start()
        getMasterSupplierList().then((response) => {
          for (let i in response.data.data) {
            this.suppliers.push({
              label: response.data.data[i].name,
              value: response.data.data[i].id
            })
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * Get List Uom
       */
      getListUom() {
        this.$Progress.start()
        getMasterUomList().then((response) => {
          for (let i in response.data.data) {
            this.uoms.push({
              label: response.data.data[i].name,
              value: response.data.data[i].id
            })
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * Get List Uom Detail
       */
      getListUomDetail() {
        this.$Progress.start()
        getMasterUomDetailList().then((response) => {
          for (let i in response.data.data) {
            this.uom_details.push(response.data.data[i])
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * Get details of object
       */
      getDetails() {
        this.$Progress.start()
        let params = {
          id: this.id
        }
        get(params).then((response) => {
          this.item = response.data.data
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Update item info to server
       */
      updateItem() {
        this.$Progress.start()
        let param = Object.assign({}, this.item)
        param.material_id           = this.item.material_id.value
        param.supplier_uom_id       = this.item.supplier_uom_id.value
        param.smaller_uom_id        = this.item.smaller_uom_id.value
        param.smaller_uom_detail_id = this.item.smaller_uom_detail_id.value
        param.outlet_uom_id         = this.item.outlet_uom_id.value
        param.outlet_uom_detail_id  = this.item.outlet_uom_detail_id.value
        param.recipe_uom_id         = this.item.recipe_uom_id.value
        param.recipe_uom_detail_id  = this.item.recipe_uom_detail_id.value
        param.report_uom_id         = this.item.report_uom_id.value
        param.fixed_unit_id         = this.item.fixed_unit_id ? this.item.fixed_unit_id.value : ''
        update(param).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Create item info to server
       */
      createItem() {
        this.$Progress.start()
        let param = Object.assign({}, this.item)
        param.material_id           = this.item.material_id.value
        param.supplier_uom_id       = this.item.supplier_uom_id.value
        param.smaller_uom_id        = this.item.smaller_uom_id.value
        param.smaller_uom_detail_id = this.item.smaller_uom_detail_id.value
        param.outlet_uom_id         = this.item.outlet_uom_id.value
        param.outlet_uom_detail_id  = this.item.outlet_uom_detail_id.value
        param.recipe_uom_id         = this.item.recipe_uom_id.value
        param.recipe_uom_detail_id  = this.item.recipe_uom_detail_id.value
        param.report_uom_id         = this.item.report_uom_id.value
        param.fixed_unit_id         = this.item.fixed_unit_id ? this.item.fixed_unit_id.value : ''

        create(param).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * Generate material detail code from server
       */
      generateMaterialDetailCode() {
        if (this.item.material_id) {
          let params = {
            material_id: this.item.material_id.value,
            material_code: this.getMaterialCode()
          }
          generateCode(params).then((response) => {
            this.item.code = response.data.data.code
          }).catch((error) => {
          })
        }
      },
      /**
       * Get material code
       */
      getMaterialCode() {
        for (let i in this.materials) {
          let material = this.materials[i];
          if (material.value == this.item.material_id.value) {
            return material.code
          }
        }
      },
    },
    created: function () {
      this.getListMaterial()
      this.getListSupplier()
      this.getListUom()
      this.getListUomDetail()
      if (this.id != null) {
        this.edit = 1;
        this.getDetails()
      } else {
        this.item.id = ''
      }
    },
    watch: {
      'item.material_id': function () {
        if (this.edit == 0) {
          this.generateMaterialDetailCode()
        }
      },
      'item.supplier_uom_id': function () {
        if (this.edit == 0) {
          this.item.smaller_uom_detail_id = ''
        }
        if (this.item.supplier_uom_id && this.item.smaller_uom_id) {
          this.getListSmallerUomDetail(this.item.supplier_uom_id.value, this.item.smaller_uom_id.value)
        }
      },
      'item.smaller_uom_id': function () {
        if (this.edit == 0) {
          this.item.smaller_uom_detail_id = ''
          this.item.outlet_uom_detail_id  = ''
        }
        if (this.item.supplier_uom_id && this.item.smaller_uom_id) {
          this.getListSmallerUomDetail(this.item.supplier_uom_id.value, this.item.smaller_uom_id.value)
        }
        if (this.item.smaller_uom_id && this.item.outlet_uom_id) {
          this.getListOutletUomDetail(this.item.smaller_uom_id.value, this.item.outlet_uom_id.value)
        }
      },
      'item.outlet_uom_id': function () {
        if (this.edit == 0) {
          this.item.outlet_uom_detail_id  = ''
          this.item.recipe_uom_detail_id  = ''
        }
        if (this.item.smaller_uom_id && this.item.outlet_uom_id) {
          this.getListOutletUomDetail(this.item.smaller_uom_id.value, this.item.outlet_uom_id.value)
        }
        if (this.item.outlet_uom_id && this.item.recipe_uom_id) {
          this.getListRecipeUomDetail(this.item.outlet_uom_id.value, this.item.recipe_uom_id.value)
        }

      },
      'item.recipe_uom_id': function () {
        if (this.edit == 0) {
          this.item.recipe_uom_detail_id  = ''
        } else {
          this.edit = 0
        }
        if (this.item.outlet_uom_id && this.item.recipe_uom_id) {
          this.getListRecipeUomDetail(this.item.outlet_uom_id.value, this.item.recipe_uom_id.value)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/inventory/master_material_detail/Form.vue